import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import api from "common/api";
import { toast } from "react-toastify";

function PasswordSetupPage() {
  const [password, setPassword] = useState<string | null>(null);
  const [passwordConfirm, setPasswordConfirm] = useState<string | null>(null);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const uid = params.get("uid");
  const token = params.get("token");

  const navigate = useNavigate();

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();

    if (password !== passwordConfirm) {
      toast.error("Lozinke se ne podudaraju");
      return;
    }

    try {
      await api.post("/accounts/users/activation/", {
        uid: uid,
        token: token,
        password: password,
        password_confirm: passwordConfirm,
      });
      toast.success("Lozinka uspješno postavljena");
      navigate("/prijava");
    } catch (error: any) {
      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data.token &&
        error.response.data.token[0] === "Invalid token for given user."
      ) {
        toast.error("Pogrešan token");
      } else if (
        error.response &&
        error.response.status === 400 &&
        error.response.data.non_field_errors
      ) {
        error.response.data.non_field_errors.forEach((errorMessage: string) => {
          switch (errorMessage) {
            case "This password is too short. It must contain at least 8 characters.":
              toast.error(
                "Lozinka je prekratka. Mora sadržavati najmanje 8 znakova.",
              );
              break;
            case "This password is too common.":
              toast.error("Lozinka je preuobičajena.");
              break;
            default:
              toast.error("Dogodila se greška");
          }
        });
      } else {
        toast.error("Dogodila se greška");
      }
    }
  };

  return (
    <Row
      className="d-flex justify-content-center align-items-center"
      style={{ height: "95vh" }}
    >
      <Col md={8} lg={6} xs={12}>
        <div className="border border-2 border-primary"></div>
        <Card className="shadow px-4">
          <Card.Body>
            <h2 className="fw-bold mb-2 text-center text-uppercase">
              Postavite lozinku
            </h2>
            <Form>
              <Form.Group className="mb-3" controlId="formGroupPassword">
                <Form.Label>Nova lozinka</Form.Label>
                <Form.Control
                  required
                  type="password"
                  placeholder="Unesize lozinku"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupPasswordConfirm">
                <Form.Label>Potvrdite lozinku</Form.Label>
                <Form.Control
                  required
                  type="password"
                  placeholder="Potvrdite lozinku"
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                />
              </Form.Group>
              <div className="d-grid">
                <Button variant="primary" type="submit" onClick={handleSubmit}>
                  Postavite lozinku
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default PasswordSetupPage;
